import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { catchError, firstValueFrom, of, switchMap, throwError } from 'rxjs';
import { DummyService } from '../services';

@Injectable()
export class AuthResolverService  {
  isLoggedUser: boolean;
  constructor(
    private dummyService: DummyService,
    private cookieService: CookieService,
    private oidcSecurityService: OidcSecurityService
  ) {}

  async resolve(): Promise<any> {
    const token = this.cookieService.get('newToken')
      ? this.cookieService.get('newToken')
      : await firstValueFrom(this.oidcSecurityService.getAccessToken());

    const isExpired = this.isTokenExpired(token);

    if (!isExpired) {
      this.isLoggedUser = true;
      return Promise.resolve(true);
    }

    if (
      this.cookieService.get('isRefreshToken') === '' ||
      this.cookieService.get('isRefreshToken') === 'false'
    ) {
      this.cookieService.set('isRefreshToken', 'true');
      const refreshToken = this.cookieService.get('refreshToken')
        ? this.cookieService.get('refreshToken')
        : await firstValueFrom(this.oidcSecurityService.getRefreshToken());

      return this.dummyService
        .getTokenUsingRefreshToken(refreshToken, environment.clientId)
        .pipe(
          switchMap((response) => {
            this.cookieService.set('isRefreshToken', 'false');
            this.cookieService.set('newToken', response.access_token);
            this.cookieService.set('refreshToken', response.refresh_token);
            this.isLoggedUser = true;

            return of(response.access_token);
          }),
          catchError((error) => {
            this.cookieService.deleteAll();
            this.oidcSecurityService.logoff().subscribe();

            return throwError('Error');
          })
        )
        .toPromise()
        .then((accessToken) => {
          this.isLoggedUser = true;

          return accessToken;
        });
    }

    this.cookieService.deleteAll();
    this.oidcSecurityService.logoff().subscribe();
    this.isLoggedUser = false;
    return Promise.resolve(false);
  }

  private isTokenExpired(token: string): boolean {
    const decodedToken = this.decodeToken(token);

    if (!decodedToken || !decodedToken.exp) {
      return true;
    }

    const currentTime = Math.floor(Date.now() / 1000);

    return decodedToken.exp < currentTime;
  }

  private decodeToken(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decodedPayload = atob(payload);

      return JSON.parse(decodedPayload);
    } catch (error) {
      return null;
    }
  }
}
